import Spinner from './Spinner';

/**
 * The only thing on screen before the app exists.
 *
 * Rendered by BOTH boot gates — `main.tsx`'s root `<Suspense>` (a suspending
 * import) and `App.tsx`'s `RouterProvider fallbackElement` (the initial
 * navigation resolving its route module) — because either can be what the user
 * is waiting on and each renders `null` without it.
 *
 * The one place in the app where the MUI-first styling rule cannot apply: this
 * renders ABOVE every provider, so there is no theme to read, and the classes
 * below are already-parsed CSS (the same string `TenantGuard` centres its
 * spinner with) rather than a themed component that would add weight to the
 * very path this exists to cover.
 */
export const FullPageSpinner = () => (
  <div className="w-full h-screen flex items-center justify-center">
    <Spinner size="large" />
  </div>
);
